import customerOwnedAwsService from '@/services/registercustomerowned.service.js'
export default {
  fetchRequests: async (context, data) => {
    console.log('Fetching customer accounts from API')
    context.commit('setIsLoading', true)
    try {
      let parameter = {}
      const hasNextPageKey = data && Object.prototype.hasOwnProperty.call(data, 'nextPageKey')
      if (hasNextPageKey) {
        parameter.nextPageKey = data.nextPageKey
      }
      if (data && data.search) {
        parameter.search = data.search
      }

      if (!hasNextPageKey || data.nextPageKey === '') {
        context.commit('clearRequests')
      }

      const requests = await customerOwnedAwsService.getCustomerOwnedAccounts(parameter)
      console.log('Customer accounts fetched successfully:', requests)
      context.commit('setRequests', requests.data)
      context.commit('setNextPageKey', requests.next_data || null)
    } catch (error) {
      console.error('Error fetching customer accounts:', error)
    } finally {
      context.commit('setIsLoading', false)
    }
  },
  approveRequest: async (context, parameters) => {
    console.log('Approving request with ID:', parameters)
    try {
      await customerOwnedAwsService.approveRequest(parameters)
      if (parameters.emailData) {
        await customerOwnedAwsService.sendEmailNotification(parameters.emailData)
      }
    } catch (error) {
      console.error('Error approving request:', error)
    }
  }
}
